var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDefined)?_c('div',[_c('vx-tooltip',{attrs:{"text":_vm.allSamples,"position":"bottom","delay":".3s"}},[_vm._v("\n    "+_vm._s(_vm.firstRange.sampleStart)+" - "+_vm._s(_vm.firstRange.sampleEnd)+" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasMultiple),expression:"hasMultiple"}]},[_vm._v("*")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }